export enum AppType {
	Commands = 1,
	IOS = 2,
	Android = 3,
	Web = 6,
	Unknown = 99
}